// Determine URL for AJAX based on current location
var url = nlsuConfig.pythonEndpoint;
var rowTemplate = null;

/**
 * Global vars
 */
var freeProductCount = 0;
var freeTable = null;
var requestType = 'GET';
var dataType = 'json';
var partLookupUrl = nlsuConfig.partLookup + '?partNumber=';
var isCanada = document.location.href.indexOf('fishersci.ca') >= 0;
var pageLanguage = LocalePath ? LocalePath.getLanguage()  : 'en';

if(isCanada){
    partLookupUrl = nlsuConfig.partLookupCA + '?partNumber=';
}

/**
 * Helper functions for vanilla JS
 */
function $$$(selector, context) {
    context = context || document;
    return context.querySelector(selector);
}

function $$(selector, context) {
    context = context || document;
    return Array.from(context.querySelectorAll(selector));
}

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
}

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function trim(str) {
    return str ? str.trim() : '';
}

function addClass(element, className) {
    if (element && !element.classList.contains(className)) {
        element.classList.add(className);
    }
}

function removeClass(element, className) {
    if (element && element.classList.contains(className)) {
        element.classList.remove(className);
    }
}

function hasClass(element, className) {
    return element ? element.classList.contains(className) : false;
}

function closest(element, selector) {
    return element ? element.closest(selector) : null;
}

function createElementFromHTML(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild;
}

function serializeForm(form) {
    var formData = new FormData(form);
    var params = new URLSearchParams();
    for (var pair of formData.entries()) {
        params.append(pair[0], pair[1]);
    }
    return params.toString();
}

function extend(defaults, options) {
    var result = {};
    for (var key in defaults) {
        result[key] = defaults[key];
    }
    for (var key in options) {
        result[key] = options[key];
    }
    return result;
}

function each(array, callback) {
    if (Array.isArray(array)) {
        array.forEach(callback);
    } else {
        Object.keys(array).forEach(function(key) {
            callback(key, array[key]);
        });
    }
}
function makeRequest(requestUrl, params, callback, method) {
    // Default to GET if method not specified
    method = method || 'GET';
    var requestOptions = {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json, application/javascript, text/html'
        },
        credentials: 'same-origin'
    };

    // Parse params.data if it exists and is a serialized string
    var finalParams = {};

    if (params.data && typeof params.data === 'string') {
        // Parse the serialized form data (e.g., "pinLookup=&emailLookup=")
        var pairs = params.data.split('&');
        pairs.forEach(function(pair) {
            var keyValue = pair.split('=');
            if (keyValue.length >= 1) {
                var key = decodeURIComponent(keyValue[0]);
                var value = keyValue.length === 2 ? decodeURIComponent(keyValue[1]) : '';
                finalParams[key] = value;
            }
        });
    }

    // Merge other params (excluding 'data' key if it was serialized form data)
    Object.keys(params).forEach(function(key) {
        if (key !== 'data' || typeof params.data !== 'string') {
            finalParams[key] = params[key];
        }
    });

    // For GET requests, add params to query string
    // For POST/PUT/DELETE, send params in the body
    if (method === 'GET') {
        // Build query string with individual parameters
        var queryString = Object.keys(finalParams).map(function(key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(finalParams[key]);
        }).join('&');

        if (queryString) {
            // Check if URL already has query params
            var separator = requestUrl.indexOf('?') >= 0 ? '&' : '?';
            requestUrl += separator + queryString;
        }
    } else {
        // For POST, PUT, DELETE, etc., send params as JSON body with individual properties
        requestOptions.body = JSON.stringify(finalParams);
    }

    console.log('[makeRequest] ' + method + ' Request:', requestUrl);
    if (method !== 'GET') {
        console.log('[makeRequest] POST body:', requestOptions.body);
    }
    if(document.location.href.indexOf('localhost') !== -1) {
        requestUrl = nlsuConfig.pythonEndpoint +  requestUrl;
    }
    fetch(requestUrl, requestOptions)
        .then(function(response) {
            console.log('[makeRequest] Response status:', response.status, response.statusText);
            if (!response.ok) {
                throw new Error('HTTP error! status: ' + response.status);
            }

            // Check Content-Type to determine how to parse the response
            var contentType = response.headers.get('content-type');
            console.log('[makeRequest] Content-Type:', contentType);

            if (contentType && contentType.indexOf('application/json') !== -1) {
                return response.json();
            } else if (contentType && contentType.indexOf('application/javascript') !== -1) {
                return response.text().then(function(text) {
                    // Try to parse as JSON, fallback to text
                    try {
                        return JSON.parse(text);
                    } catch (e) {
                        console.log('[makeRequest] Could not parse as JSON, returning as text');
                        return text;
                    }
                });
            } else {
                // Default to text/HTML
                return response.text();
            }
        })
        .then(function(data) {
            console.log('[makeRequest] Data received:', data);
            callback(data);
        })
        .catch(function(error) {
            console.error('[makeRequest] Request error:', error);
            if (callback) {
                callback({ error: error.message });
            }
        });
}

// Convert form data to an object
/*function formToNestedObject(form) {
    var obj = {};
    var formData = new FormData(form);

    formData.forEach(function(value, key) {
        var match = key.match(/^(\w+)\[(\w+)\]$/);
        if (match) {
            var parent = match[1];
            var child = match[2];
            obj[parent] = obj[parent] || {};
            obj[parent][child] = value;
        } else {
            obj[key] = value;
        }
    });

    return obj;
}*/
function formToNestedObject(form) {
    var obj = {};
    var formData = new FormData(form);

    formData.forEach(function(value, key) {
        if (value instanceof File) {
            return;
        }
        // Handle array notation (e.g., catalogNumber[])
        if (key.endsWith('[]')) {
            var arrayKey = key.slice(0, -2); // Remove the '[]'
            if (!obj[arrayKey]) {
                obj[arrayKey] = [];
            }
            obj[arrayKey].push(value);
        }
        // Handle nested object notation (e.g., user[name])
        else {
            var match = key.match(/^(\w+)\[(\w+)\]$/);
            if (match) {
                var parent = match[1];
                var child = match[2];
                obj[parent] = obj[parent] || {};
                obj[parent][child] = value;
            } else {
                obj[key] = value;
            }
        }
    });

    return obj;
}

var REDEEM_ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;
var REDEEM_ATTACHMENT_ACCEPT = '.pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png';
var REDEEM_ATTACHMENT_ALLOWED_MIME_TYPES = {
    'application/pdf': true,
    'image/jpeg': true,
    'image/jpg': true,
    'image/pjpeg': true,
    'image/png': true
};
var REDEEM_ATTACHMENT_ALLOWED_EXTENSIONS = {
    '.pdf': true,
    '.jpg': true,
    '.jpeg': true,
    '.png': true
};

function showRedeemAttachmentMessage(message) {
    if (window.jQuery && window.jQuery.colorbox) {
        jQuery.colorbox({
            html: "<div class='modal common_modal login'>" + message + '</div>'
        });
    }
}

function getFileExtension(fileName) {
    if (!fileName || fileName.indexOf('.') === -1) {
        return '';
    }
    return fileName.slice(fileName.lastIndexOf('.')).toLowerCase();
}

function isAllowedRedeemAttachment(file) {
    if (!file) {
        return false;
    }

    var normalizedMimeType = (file.type || '').toLowerCase();
    var normalizedExtension = getFileExtension(file.name || '');
    var mimeAllowed = !!REDEEM_ATTACHMENT_ALLOWED_MIME_TYPES[normalizedMimeType];
    var extensionAllowed = !!REDEEM_ATTACHMENT_ALLOWED_EXTENSIONS[normalizedExtension];

    // Some browsers/files omit or misreport MIME type, so allow a known extension as fallback.
    return mimeAllowed || extensionAllowed;
}

function validateRedeemAttachment() {
    var attachmentInput = $$$('#redeemAttachment');
    if (!attachmentInput) {
        return true;
    }

    var files = attachmentInput.files || [];
    if (files.length !== 1) {
        showRedeemAttachmentMessage(files.length > 1 ? 'Please attach only one file.' : 'Please attach one file before submitting.');
        return false;
    }

    var file = files[0];
    if (!isAllowedRedeemAttachment(file)) {
        showRedeemAttachmentMessage('Please upload a PDF, JPG, or PNG file only.');
        return false;
    }

    if (file.size > REDEEM_ATTACHMENT_MAX_BYTES) {
        showRedeemAttachmentMessage('Please upload a file that is 10MB or smaller.');
        return false;
    }

    return true;
}

function attachFileToPayload(registration, payload, callback) {
    var attachmentInput = $$$('#redeemAttachment');
    if (!attachmentInput || !attachmentInput.files || attachmentInput.files.length === 0) {
        callback(payload);
        return;
    }

    var file = attachmentInput.files[0];
    if (!isAllowedRedeemAttachment(file) || file.size > REDEEM_ATTACHMENT_MAX_BYTES) {
        callback(payload);
        return;
    }

    var reader = new FileReader();
    reader.onload = function() {
        var rawResult = typeof reader.result === 'string' ? reader.result : '';
        var parts = rawResult.split(',');
        payload.attachment = {
            fileName: file.name,
            contentType: file.type || 'application/octet-stream',
            contentBase64: parts.length > 1 ? parts[1] : rawResult
        };
        callback(payload);
    };
    reader.onerror = function() {
        callback(payload);
    };
    reader.readAsDataURL(file);
}
/**
 * Initialize when DOM is ready
 */
document.addEventListener('DOMContentLoaded', function() {
    // Cache common elements
    var freeProductBodyRows = $$('.js-free-product-body tr');
    if (freeProductBodyRows.length > 0) {
        rowTemplate = freeProductBodyRows[0].cloneNode(true);
    }
    freeTable = $$$('#freeProductTable');

    //update unique IDs
    updateId();

    /**
     * Pre-populate lookup box if cookies are available
     */
    var pinLookup = $$$('#pinLookup');
    var emailLookup = $$$('#emailLookup');

    //Do manufacturer lookup if cookies are set
    if (getCookie('NLSUPin') !== null && getCookie('NLSUEmail') !== null) {
        getManufacturerDropDown();
    }

    //Hide optional Serial Number field by default
    var serialNumber = $$$('#serialNumber');
    if (serialNumber) {
        var serialRow = closest(serialNumber, '.row');
        if (serialRow) addClass(serialRow, 'hide');
    }

    //Hide PDF icon
    $$('.js-nlsu-download').forEach(function(el) {
        el.remove();
    });

    var redeemAttachment = $$$('#redeemAttachment');
    if (redeemAttachment) {
        redeemAttachment.setAttribute('accept', REDEEM_ATTACHMENT_ACCEPT);
    }

    /**
     * Listen to offers drop down, set hidden var = to text
     */
    var offerIDNumber = $$$('#offerIDNumber');
    if (offerIDNumber) {
        offerIDNumber.addEventListener('change', function() {
            var _this = this;

            //Clear any existing products and free item form
            if (freeTable) {
                var tbody = freeTable.querySelector('tbody');
                if (tbody) tbody.innerHTML = '';
            }

            $$('.js-nlsu-table tr').forEach(function(row) {
                resetRow({
                    element: row,
                    clearCatalogNumber: true
                });
            });

            if (_this.value !== "") {
                var selectedOption = _this.options[_this.selectedIndex];
                var selectedText = selectedOption.text;

                var offerTranslated = $$$('#offerTranslated');
                if (offerTranslated) {
                    offerTranslated.value = selectedText;
                }

                //Get associated free products
                doGetFreeProducts({
                    promoKey: _this.value,
                    link: selectedOption.getAttribute('data-link')
                });

                //Update hidden variable to match currently selected promo
                var promoKey = $$$('#promoKey');
                if (promoKey) promoKey.value = _this.value;

                //Pull in any pre-existing non-submitted records based on nlsID and sessionID
                var nlsIDForMain = $$$('#nlsIDForMain');
                var sessionIDForMain = $$$('#sessionIDForMain');
                doFreePartRefresh({
                    nlsID: nlsIDForMain ? nlsIDForMain.value : '',
                    sessionID: sessionIDForMain ? sessionIDForMain.value : '',
                    promoKey: _this.value
                });

            } else {
                var promoKey = $$$('#promoKey');
                if (promoKey) promoKey.value = '';
                var addNewProduct = $$$('#addNewProduct');
                if (addNewProduct) addClass(addNewProduct, 'hide');
                if(freeTable) addClass(freeTable, 'hide');
            }
        });
    }

    //Look up part number when input field value changes
    var nlsuTable = $$$('.js-nlsu-table');
    if (nlsuTable) {
        nlsuTable.addEventListener('change', function(e) {
            if (e.target.classList.contains('js-catalognumber')) {
                var _this = e.target;
                var closestRow = closest(_this, 'tr');

                //No searching if empty..
                if (trim(_this.value) === '') {
                    resetRow({
                        element: closestRow
                    });
                    return;
                }

                //update list price field
                var listPriceInput = closestRow.querySelector('[name="listPrice[]"]');
                if (listPriceInput) listPriceInput.value = 'searching part number...';

                lookUpPart({
                    part: _this.value,
                    element: _this,
                    callback: updateUi
                });
            }
        });

        //Update totals when List Price or Qty change
        nlsuTable.addEventListener('change', function(e) {
            if (e.target.matches('[name="listPrice[]"]') || e.target.classList.contains('js-qty')) {
                updateTotal({
                    element: closest(e.target, 'tr')
                });
                updateGrandTotal();
            }
        });
    }

    //Add new rows dynamically
    $$('#addAdditionalRow').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            addRow();
        });
    });

    /**
     * Listen to changes on manufacturer drop down
     */
    var manufacturerID = $$$('#manufacturerID');
    if (manufacturerID) {
        manufacturerID.addEventListener('change', function() {
            var _this = this;

            updateId();

            //update timestamp session ID
            Math.round((new Date()).getTime() / 1000);

            /**
             * Remove any existing Offers and qualifying parts
             */
            $$('[data-type="offers"]').forEach(function(el) {
                el.remove();
            });
            doClearQualifyingParts();

            //Clear any existing products
            if (freeTable) {
                var tbody = freeTable.querySelector('tbody');
                if (tbody) tbody.innerHTML = '';
            }

            //Reset hidden PromoKey
            var promoKey = $$$('#promoKey');
            if (promoKey) promoKey.value = '';
            var addNewProduct = $$$('#addNewProduct');
            if (addNewProduct) addClass(addNewProduct, 'hide');
            if(freeTable) addClass(freeTable, 'hide')

            /**
             * Set hidden var
             */
            var selectedOption = _this.options[_this.selectedIndex];
            var selectedText = selectedOption.text;
            var manufacturerTranslated = $$$('#manufacturerTranslated');
            if (manufacturerTranslated) {
                manufacturerTranslated.value = selectedText;
            }

            /**
             * Make the width auto
             */
            var offerIDNumber = $$$('#offerIDNumber');
            if (offerIDNumber) offerIDNumber.style.width = 'auto';

            /**
             * Only fire AJAX if manufacturer has been selected
             */
            if (trim(_this.value) !== "") {
                makeRequest('/marketing-api/nlsu/getoffers', {
                    dataType: 'o',
                    manufacturerId: _this.value,
                    country: 'US'
                }, function(msg) {
                    if (msg['offers'] === null) {
                        if (window.jQuery && window.jQuery.colorbox) {
                            jQuery.colorbox({
                                html: "<div class='modal common_modal login'>There was an issue getting offer data - please refresh the page and try again</div>"
                            });
                        }
                    } else {
                        each(msg['offers'], function(key, val) {
                            var option = document.createElement('option');
                            option.value = key.promoKey;
                            option.setAttribute('data-type', 'offers');
                            option.setAttribute('data-link', key.usLink);
                            option.textContent = key.linkText;
                            if (offerIDNumber) offerIDNumber.appendChild(option);
                        });
                    }
                });
            } else {
                $$('[data-type="offers"]').forEach(function(el) {
                    el.remove();
                });
            }
        });
    }

    /**
     * use delegate to listen to all 'remove' links
     * as they will be added on the fly
     */
    if (freeTable) {
        freeTable.addEventListener('click', function(e) {
            if (e.target.tagName === 'A') {
                e.preventDefault();
                var productToRemove = e.target.getAttribute('data-product-id');

                if (confirm("Are you sure you want to remove this item?")) {
                    makeRequest('deleteFreeProduct.php', {
                        redemptionID: productToRemove
                    }, function(msg) {
                        if (msg == "1") {
                            if (window.jQuery && window.jQuery.colorbox) {
                                jQuery.colorbox({
                                    html: "<div class='modal common_modal login'>Product removed successfully</div>"
                                });
                            }
                        } else {
                            if (window.jQuery && window.jQuery.colorbox) {
                                jQuery.colorbox({
                                    html: "<div class='modal common_modal login'>There was an issue removing the product - please try again</div>"
                                });
                            }
                        }

                        /* Hide table if all products are removed */
                        if (freeProductCount == 0) {
                            addClass(freeTable, 'hide');
                        }
                    });
                }

                /* Hide row */
                var row = closest(e.target, 'tr');
                if (row) addClass(row, 'hide');

                /* Update free product count */
                if (freeTable) {
                    var tbody = freeTable.querySelector('tbody');
                    if (tbody) {
                        freeProductCount = tbody.children.length;
                    }
                }
            }
        });
    }

    //Listen for click to qualifying parts link
    var registrationContainer = $$$('#registrationContainer');
    if (registrationContainer) {
        registrationContainer.addEventListener('click', function(e) {
            if (e.target.id === 'qualifyingLink') {
                doShowQualifyingParts(e);
            }
        });
    }

    //Listen to add qualifying parts to request
    var qualifyingPartContainer = $$$('#qualifyingPartContainer');
    if (qualifyingPartContainer) {
        qualifyingPartContainer.addEventListener('click', function(e) {
            if (e.target.id === 'addQualifyingParts') {
                doAddQualifyingParts();
            }
        });
    }

    /**
     * Close Free Product window
     */
    var closeFreeProduct = $$$('#closeFreeProduct');
    if (closeFreeProduct) {
        closeFreeProduct.addEventListener('click', function(e) {
            e.preventDefault();
            if (window.jQuery && window.jQuery.colorbox) {
                jQuery.colorbox.close();
            }
        });
    }

    /**
     * Look up NLSU data based on
     * Pin number and e-mail address
     * 2012.0210 - Set cookies for PIN and Email and prepopulate fields
     */
    var lookupButton = $$$('#lookupButton');
    if (lookupButton) {
        lookupButton.addEventListener('click', function() {
            /**
             * Block UI to show lookup
             */
            if (window.jQuery && window.jQuery.colorbox) {
                jQuery.colorbox({
                    html: "<div class='modal common_modal login'>Searching..</div>"
                });
            }

            /**
             * Set cookies
             */
            var pinLookup = $$$('#pinLookup');
            var emailLookup = $$$('#emailLookup');
            setCookie('NLSUPin', pinLookup ? pinLookup.value : '');
            setCookie('NLSUEmail', emailLookup ? emailLookup.value : '');

            /**
             * change button wording
             */
            lookupButton.value = "Please wait...";

            var doLookup = $$$('#doLookup');
            makeRequest('/marketing-api/nlsu/userlookup', {
                data: doLookup ? serializeForm(doLookup) : ''
            }, function(msg) {
                let msgJson;
                /**
                 * Adjust button text
                 */
                lookupButton.value = "Search";

                if (window.jQuery && window.jQuery.colorbox) {
                    jQuery.colorbox.close();
                }

                /* Adjust message variable based on data*/
                var message = '';
                var showForm = true;

                //Add Status and Approval field
                var registration = $$$('#registration');
                if (registration) {
                    registration.insertAdjacentHTML('beforeend', '<input type="hidden" name="status" id="redeem_Status">');
                    registration.insertAdjacentHTML('beforeend', '<input type="hidden" name="When_Approved" id="redeem_When_Approved">');
                }

                /**
                 * No records
                 */
                if (msg['user'] === null) {
                    showForm = false;
                    var nlsuMessages = $$$('#nlsuMessages');
                    if (nlsuMessages) {
                        removeClass(nlsuMessages, 'hide');
                        nlsuMessages.innerHTML = '<p>We are unable to locate a matching record for the information you provided.  Please fill out the <a href="//www.fishersci.com/us/en/scientific-products/special-offers-and-programs/new-lab-start-up-program/apply-the-new-lab-start-up-program.html">New Lab Start-Up Program application</a> to get started.</p>';
                        addClass(nlsuMessages, 'negativeMessage');
                        nlsuMessages.style.textAlign = 'left';
                    }
                }
                if(msg['user']){
                    each(msg['user'], function(key, value) {
                        var field = $$$('#redeem_' + key);
                        if (field) field.value = value;
                    });
                    /* Set value of nslIDForMain = nslID */
                    var redeemNlsID = $$$('#redeem_nlsID');
                    var nlsIDForMain = $$$('#nlsIDForMain');
                    if (redeemNlsID && nlsIDForMain) {
                        var nlsID = redeemNlsID.value;
                        nlsIDForMain.value = nlsID;
                    }

                    /**
                     * If age of pin > 180, show message to contact NLSU Support
                     */
                    if ((msg['user']['yearPinNumber'] === "N" && parseInt(msg['user']['pinAge']) > 180) ||
                        (msg['user']['yearPinNumber'] === "Y" && parseInt(msg['user']['pinAge']) > 365)) {
                        showForm = false;
                        var nlsuMessages = $$$('#nlsuMessages');
                        if (nlsuMessages) {
                            removeClass(nlsuMessages, 'hide');
                            nlsuMessages.innerHTML = '<p>It appears that your pin number has expired.  Please e-mail <a href="mailto:NewLabStartup@Thermo.com?subject=Expired Pin Number">NewLabStartup@Thermo.com</a> for information on how to proceed.</p>';
                            addClass(nlsuMessages, 'negativeMessage');
                            nlsuMessages.style.textAlign = 'center';
                        }
                    }
                }
                /**
                 * If showForm == true, show it
                 */
                if (showForm) {
                    getManufacturerDropDown();
                    var registrationContainer = $$$('#registrationContainer');
                    var doLookupContainer = $$$('#doLookupContainer');
                    if (registrationContainer) removeClass(registrationContainer, 'hide');
                    if (doLookupContainer) addClass(doLookupContainer, 'hide');

                    //Add locale to country so we can extract language
                    $$('#redeem_Country option').forEach(function(option) {
                        if (option.value !== "0") {
                            option.value = option.value + " " + getCookie('locale');
                        }
                    });
                }
            },'POST');
        });
    }

    /**
     * Date Picker - keeping jQuery UI dependency for datepicker
     */
    var dateOfStartUp = $$$('#Date_Of_Start_Up');
    if (dateOfStartUp && window.jQuery && window.jQuery.fn.datepicker) {
        jQuery(dateOfStartUp).datepicker({
            showButtonPanel: true,
            minDate: null,
            maxDate: null,
            dateFormat: 'yy-mm-dd',
            constrainInput: false,
            showOn: 'both',
            buttonImageOnly: true,
            buttonImage: '/etc/designs/fishersci/images/icons/calendar.png'
        });
    }

    /**
     * Validate form
     */
    var submitButtonRedeem = $$$('#SubmitButtonRedeem');
    if (submitButtonRedeem) {
        submitButtonRedeem.addEventListener('click', function(e) {
            /*Don't submit - will handle via AJAX */
            e.preventDefault();

            // Reset counter
            freeProductCount = 0;

            // Check to see if free product table has valid qty and parts
            $$('.js-qty').forEach(function(qtyField) {
                if (trim(qtyField.value) !== "") {
                    var row = closest(qtyField, 'tr');
                    var catalogNumber = row ? row.querySelector('.js-catalognumber') : null;
                    if (catalogNumber && trim(catalogNumber.value) !== "") {
                        freeProductCount++;
                    }
                }
            });

            /**
             * If errors, don't submit form
             */
            var registration = $$$('#registration');
            var formValid = true;
            if (window.fishersci && window.fishersci.Forms && window.fishersci.Forms.processForm) {
                formValid = fishersci.Forms.processForm($(registration)); //Forms has a jQuery dependency, so we'll wrap registration in jQuery
            }

            if (!validateRedeemAttachment()) {
                return;
            }

            if (freeProductCount == 0 || !formValid) {
                var title = '';
                var msg = '';
                if (freeProductCount == 0) {
                    title = 'No Free Products Entered';
                    msg = 'Please add at least one free product before submitting form.';

                    if (window.jQuery && window.jQuery.colorbox) {
                        jQuery.colorbox({
                            html: "<div class='modal common_modal login'>" + msg + "</div>"
                        });
                    }
                }
            } else {
                //Update product description to include UOM
                $$('.js-list-price').forEach(function(listPriceEl) {
                    var select = listPriceEl.querySelector('select');
                    if (select) {
                        var uom = select.options[select.selectedIndex].text;
                        var row = closest(listPriceEl, 'tr');
                        var desc = row ? row.querySelector('.js-description') : null;

                        if (desc && trim(desc.value) !== "") {
                            desc.value = desc.value + "(" + uom + ")";
                        }
                    }
                });

                /* Send request */
                if (window.jQuery && window.jQuery.colorbox) {
                    jQuery.colorbox({
                        html: "<div class='modal common_modal login'>Processing, please wait...</div>"
                    });
                }

                var submissionPayload = registration ? formToNestedObject(registration) : {};
                attachFileToPayload(registration, submissionPayload, function(payload) {
                    makeRequest("/marketing-api/nlsu/freeProductSubmit",
                        payload
                    , function(msg) {
                        /* Thank you message / redirect page if success */
                        if (msg == '1') {
                            if (window.jQuery && window.jQuery.colorbox) {
                                jQuery.colorbox({
                                    html: "<div class='modal common_modal login'>Thank you for your submission.  You will receive an automated e-mail shortly.</div>"
                                });
                            }
                        } else {
                            if (window.jQuery && window.jQuery.colorbox) {
                                jQuery.colorbox({
                                    html: "<div class='modal common_modal login'>There was an error submitting your request, please retry.</div>"
                                });
                            }
                        }
                    },'POST');
                });
            }
        });
    }

    /**
     * Validate free product form
     */
    var addFreeProductButton = $$$('#addFreeProductButton');
    if (addFreeProductButton) {
        addFreeProductButton.addEventListener('click', function() {
            var addFreeProductForm = $$$('#addFreeProductForm');
            var formValid = true;

            if (window.fishersci && window.fishersci.Forms && window.fishersci.Forms.processForm) {
                formValid = fishersci.Forms.processForm(addFreeProductForm);
            }

            if (formValid) {
                makeRequest("addFreeProduct.php", {
                    data: addFreeProductForm ? serializeForm(addFreeProductForm) : ''
                }, function(msg) {
                    if (msg == '0') {
                        if (window.jQuery && window.jQuery.colorbox) {
                            jQuery.colorbox({
                                html: "<div class='modal common_modal login'>There was an issue making your request - please try again.</div>"
                            });
                        }
                    } else {
                        //Close free product modal
                        if (window.jQuery && window.jQuery.colorbox) {
                            jQuery.colorbox.close({
                                onClosed: function() {
                                    //Show msg
                                    jQuery.colorbox({
                                        html: "<div class='modal common_modal login'>Product added successfully.</div>",
                                        onCleanup: function() {
                                            var qualifyingPartContainer = $$$('#qualifyingPartContainer');
                                            if (qualifyingPartContainer) addClass(qualifyingPartContainer, 'hide');
                                        }
                                    });
                                }
                            });
                        }

                        //Add the product info to the table
                        if (freeTable) {
                            var row = '<tr><td>' + msg['catalogNumber'] + '</td><td><a href="#" data-product-id="' + msg['insertID'] + '">remove</a></td></tr>';
                            freeTable.insertAdjacentHTML('beforeend', row);
                        }

                        /* Update product count */
                        if (freeTable) {
                            var tbody = freeTable.querySelector('tbody');
                            if (tbody) {
                                freeProductCount = tbody.children.length;
                            }
                        }

                        /* Show the table if freeProductCount > 0 */
                        if (freeProductCount > 0 && freeTable) {
                            removeClass(freeTable, 'hide');
                        }
                    }
                });
            }
        });
    }
});

function updateUi(options) {
    var element = options.element;
    var closestRow = closest(element, 'tr');
    var qtyField = closestRow ? closestRow.querySelector('.js-qty') : null;

    _parseFrenchCurrency = function(value) {
        // Remove spaces and currency symbols, keep digits, comma, and dot
        var cleaned = value.replace(/[^\d,\.]/g, '').replace(/\s/g, '');
        // Replace comma with dot for decimal
        cleaned = cleaned.replace(',', '.');
        // Parse as float and format to 2 decimals
        var num = parseFloat(cleaned);
        return isNaN(num) ? '0.00' : num.toFixed(2);
    }

    //Remove any existing errors
    if (closestRow) {
        $$('.error', closestRow).forEach(function(el) {
            el.remove();
        });
    }

    //Loop and create list prices
    if (options.data.priceUoms) {
        var listPriceSelect = document.createElement('select');
        listPriceSelect.name = 'listPrice[]';
        listPriceSelect.className = 'element-wide element-tall';

        var listPriceContainer = closestRow ? closestRow.querySelector('.js-list-price') : null;
        if (listPriceContainer) {
            listPriceContainer.innerHTML = '';
            listPriceContainer.appendChild(listPriceSelect);
        }
        if(isCanada){
            each(options.data.priceUoms, function(k, v) {
                //strip dollar signs
                var itemPrice = k.itemPrice;
                var option = document.createElement('option');

                if(itemPrice){
                    if(pageLanguage === 'fr'){
                        itemPrice = _parseFrenchCurrency(itemPrice);
                    } else {
                        itemPrice = itemPrice.replace('$', '');
                    }
                }
                option.value = itemPrice;
                option.textContent = k.displayUnitString + ' for ' + k.itemPrice;
                listPriceSelect.appendChild(option);
            });
        } else {
            each(options.data.priceUoms, function(k, v) {
                //strip dollar signs
                var listPrice = k.listPrice.replace('$', '');
                var option = document.createElement('option');
                option.value = listPrice;
                option.textContent = k.displayUnitString + ' for ' + k.listPrice;
                listPriceSelect.appendChild(option);
            });
        }


        //Update description
        var descField = closestRow ? closestRow.querySelector('.js-description') : null;
        if (descField) {
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = options.data.productName;
            descField.value = tempDiv.textContent;
        }

        //Default qty to 1 if they don't supply one
        if (qtyField && (isNaN(qtyField.value) || trim(qtyField.value) === '')) {
            qtyField.value = '1';
        }

        //Update row total
        updateTotal({
            element: closestRow
        });

    } else {
        //reset back to free form, wipe description, total, etc
        resetRow({
            element: closestRow
        });

        if (options.data.productErrors != '') {
            element.insertAdjacentHTML('afterend', '<div class="js-error error">' + options.data.productErrors + '</div>');
        }
    }

    //update grand total
    updateGrandTotal();
}

function addRow() {
    if (!rowTemplate) return;

    var newRow = rowTemplate.cloneNode(true);
    var lastTd = newRow.querySelector('td:last-child');
    if (lastTd) {
        addClass(lastTd, 'remove');
        lastTd.innerHTML = 'X';
        lastTd.addEventListener('click', function() {
            var row = closest(this, 'tr');
            if (row) row.remove();
        });
    }

    var freeProductBody = $$$('.js-free-product-body');
    if (freeProductBody) {
        freeProductBody.appendChild(newRow);
    }
}

function resetRow(options) {
    var freeFormListPrice = '<input type="text" name="listPrice[]"  maxlength="16" data-free-product="yes"/>';

    if (!options.element) {
        return;
    }

    //wipe part number if option is set
    if (options.clearCatalogNumber) {
        var catalogNumber = options.element.querySelector('.js-catalognumber');
        if (catalogNumber) catalogNumber.value = '';
    }

    var listPrice = options.element.querySelector('.js-list-price');
    var description = options.element.querySelector('.js-description');
    var total = options.element.querySelector('.js-total');
    var qty = options.element.querySelector('.js-qty');

    if (listPrice) listPrice.innerHTML = freeFormListPrice;
    if (description) description.value = '';
    if (total) total.value = '';
    if (qty) qty.value = '';

    //update grand total
    updateGrandTotal();
}

function getUserType() {
    return (window.env && window.env.userType) || 'R';
}

function lookUpPart(options) {
    var part = options.part;
    var callback = options.callback || false;
    var element = options.element || {};

    if (isCanada) {
        // POST as x-www-form-urlencoded with required parameters
        var params = new URLSearchParams({
            storeId: '10652',
            langId: '-1',
            partNumber: part
        }).toString();

        fetch(partLookupUrl + part, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json, application/javascript, text/html'
            },
            body: params,
            credentials: 'same-origin'
        })
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                console.log(data);
                if (callback) {
                    callback({
                        element: element,
                        data: data
                    });
                }
            })
            .catch(function(error) {
                console.log(error);
            });

    } else {
        fetch(partLookupUrl + part)
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                console.log(data);
                if (callback) {
                    callback({
                        element: element,
                        data: data
                    });
                }
            })
            .catch(function(error) {
                console.log(error);
            });
    }
}


function updateTotal(options) {
    //reference the current row and update the total (list X qty)
    if (!options.element) {
        return;
    }

    var qtyField = options.element.querySelector('.js-qty');
    var listPriceSelect = options.element.querySelector('.js-list-price select');
    var totalField = options.element.querySelector('.js-total');

    if (!qtyField || !totalField) return;

    var qty = qtyField.value;
    var listPrice = listPriceSelect ? listPriceSelect.value : '0';

    totalField.value = !isNaN(qty * listPrice) ? (qty * listPrice).toFixed(2) : '0.00';
}

function updateGrandTotal() {
    var grandTotal = 0;
    $$('.js-total').forEach(function(totalField) {
        grandTotal += parseFloat(totalField.value) || 0;
    });

    $$('.js-grand-total').forEach(function(el) {
        el.textContent = grandTotal.toFixed(2);
    });
}

/**
 * doGetFreeProducts()
 * @param	args	object
 */
function doGetFreeProducts(options) {
    var defaults = {
        promoKey: '12345'
    };

    var settings = extend(defaults, options);
    var promoNumberArray = settings.promoKey.split("-");

    //Delete any existing PDF icons
    $$('.js-nlsu-download').forEach(function(el) {
        el.remove();
    });

    //Add reference to HTML promo page
    /*if (settings.link != "N/A") {
        var addNewProduct = $$$('#addNewProduct');
        if (addNewProduct) {
            var link = '<a class="js-nlsu-download" target="_blank" href="' + settings.link + '">Visit the original promotion page to see a list of redeemable products</a>';
            addNewProduct.insertAdjacentHTML('afterbegin', link);
        }
    }*/
    //TODO - check on getQualifyingProducts.php availability
    /*makeRequest('getQualifyingProducts.php', {
        promoKey: settings.promoKey
    }, function(data) {
        var response = data[0];
        var partArray = '';

        //If qualifying parts exist, update view
        if (response !== '0') {
            if (response.toomanyparts && response.toomanyparts !== 'Y') {
                partArray = response.parts.split(',');
                var qualifyingOfferCount = $$$('#qualifyingOfferCount');
                if (qualifyingOfferCount) {
                    qualifyingOfferCount.innerHTML = partArray.length + ' parts available <a href="#qualifyingPartContainer" id="qualifyingLink" class="link">( view parts )</a>';
                }
                var addNewProduct = $$$('#addNewProduct');
                if (addNewProduct) addClass(addNewProduct, 'hide');

                // Build part table
                doBuildPartTable(partArray);

            } else {
                doClearQualifyingParts();
                var addNewProduct = $$$('#addNewProduct');
                if (addNewProduct) removeClass(addNewProduct, 'hide');
            }

            //order number required or not
            var orderNumber = $$$('#orderNumber');
            var orderOptional = $$$('#orderOptional');
            if (response.ordernumberrequired === 'N') {
                if (orderNumber) orderNumber.removeAttribute('data-form-validity');
                if (orderOptional) removeClass(orderOptional, 'hide');
            } else {
                if (orderNumber) orderNumber.setAttribute('data-form-validity', '');
                if (orderOptional) addClass(orderOptional, 'hide');
            }

            //serial number required or not
            var serialNumber = $$$('#serialNumber');
            var serialOptional = $$$('#serialOptional');
            if (response.serialNumberRequired === 'Y') {
                if (serialNumber) {
                    serialNumber.setAttribute('data-form-validity', '');
                    serialNumber.setAttribute('data-form-required-field', '');
                    serialNumber.setAttribute('data-form-error-message', 'This field is required');
                    var serialRow = closest(serialNumber, '.row');
                    if (serialRow) removeClass(serialRow, 'hide');
                }
                if (serialOptional) addClass(serialOptional, 'hide');
            } else {
                if (serialNumber) {
                    serialNumber.removeAttribute('data-form-validity');
                    serialNumber.removeAttribute('data-form-required-field');
                    serialNumber.removeAttribute('data-form-error-message');
                    var serialRow = closest(serialNumber, '.row');
                    if (serialRow) addClass(serialRow, 'hide');
                }
                if (serialOptional) removeClass(serialOptional, 'hide');
            }
        } else {
            doClearQualifyingParts();
            var addNewProduct = $$$('#addNewProduct');
            if (addNewProduct) removeClass(addNewProduct, 'hide');
        }
    });*/
}

/**
 * Redirect
 */
function redirect(newLocation) {
    window.location = newLocation;
}

function doClearQualifyingParts(args) {
    var qualifyingOfferCount = $$$('#qualifyingOfferCount');
    var qualifyingPartContainer = $$$('#qualifyingPartContainer');

    if (qualifyingOfferCount) qualifyingOfferCount.innerHTML = '';
    if (qualifyingPartContainer) qualifyingPartContainer.innerHTML = '';
}

function doShowQualifyingParts(e) {
    console.log(e);

    if (window.jQuery && window.jQuery.colorbox) {
        jQuery.colorbox({
            onOpen: function() {
                var qualifyingPartContainer = $$$('#qualifyingPartContainer');
                if (qualifyingPartContainer) removeClass(qualifyingPartContainer, 'hide');
            },
            inline: true,
            href: '#qualifyingPartContainer',
            'width': '375px',
            open: true,
            onCleanup: function() {
                var qualifyingPartContainer = $$$('#qualifyingPartContainer');
                if (qualifyingPartContainer) addClass(qualifyingPartContainer, 'hide');
            }
        });
    }
}

function doBuildPartTable(args) {
    var partLen = args.length;

    if (partLen === 0) {
        return false;
    }

    //remove existing form
    var qualifyingParts = $$$('#qualifyingParts');
    if (qualifyingParts) qualifyingParts.remove();

    var partTable = '' +
        '<form name="qualifyingParts" id="qualifyingParts">' +
        '<table>' +
        '<tr>' +
        '<th> Part Number</th>' +
        '<th> Qty</th>' +
        '</tr>' +
        '</table>';

    for (var i = 0; i < partLen; i++) {
        partTable += '' +
            '<div class="row form_field">' +
            '<div class="large-9 medium-4 small-12 columns">' +
            '<label for="qp_qty_' + trim(args[i]) + '">' + args[i] + '</label>' +
            '</div>' +
            '<div class="large-3 medium-8 small-12 columns">' +
            '<fieldset>' +
            '<input type="text" maxlength="4" name="qualifyingProductQty[]" id="qp_qty_' + trim(args[i]) + '"/>' +
            '<input type="hidden" name="qualifyingProduct[]" id="qp_' + trim(args[i]) + '" value="' + trim(args[i]) + '"/>' +
            '</fieldset>' +
            '</div>' +
            '</div>';
    }

    var redeemNlsID = $$$('#redeem_nlsID');
    var promoKey = $$$('#promoKey');
    var sessionID = $$$('#sessionID');

    partTable += '' +
        '<div class="row">' +
        '<div class="columns">' +
        '<a class="btn" id="addQualifyingParts" href="javascript:void(0)">Save</a>' +
        '</div>' +
        '</div>' +
        '<input type="hidden" name="qualifyingNlsID" id="qualifyingNlsID" value="' + (redeemNlsID ? redeemNlsID.value : '') + '"/>' +
        '<input type="hidden" name="qualifyingPromoKey" id="qualifyingPromoKey" value="' + (promoKey ? promoKey.value : '') + '"/>' +
        '<input type="hidden" name="qualifyingSessionID" id="qualifyingSessionID" value="' + (sessionID ? sessionID.value : '') + '"/>' +
        '</form>';

    var qualifyingPartContainer = $$$('#qualifyingPartContainer');
    if (qualifyingPartContainer) {
        qualifyingPartContainer.insertAdjacentHTML('beforeend', partTable);
    }
}

function doFreePartRefresh(args) {
    makeRequest("/marketing-api/nlsu/freeProductRefresh", {
        nlsID: args.nlsID,
        sessionID: args.sessionID,
        promoKey: args.promoKey
    }, function(msg) {
        var tableRow = '';

        var addNewProduct = $$$('#addNewProduct');
        if (addNewProduct) removeClass(addNewProduct, 'hide');
        if(freeTable) removeClass(freeTable, 'hide')

        //Add the product info to the table
        if (msg['catalogNumber'] && msg['catalogNumber'].length > 0) {
            each(msg['catalogNumber'], function(key, val) {
                tableRow += '' +
                    '<tr>' +
                    '<td>' + val[0] + '</td>' +
                    '<td>' +
                    '<a href="#" data-product-id="' + val[1] + '">remove</a>' +
                    '</td>' +
                    '</tr>';
            });
            if (freeTable) {
                freeTable.insertAdjacentHTML('beforeend', tableRow);
            }
        }
    });
}

function doAddQualifyingParts(args) {
    var totalFields = $$('[name^="qualifyingProductQty"]').length;
    var emptyCount = 0;

    $$('[name^="qualifyingProductQty"]').forEach(function(field) {
        var val = trim(field.value);
        if (val === "") {
            emptyCount++;
        }
    });

    //if no qty fields are filled out
    if (emptyCount === totalFields) {
        var addQualifyingParts = $$$('#addQualifyingParts');
        if (addQualifyingParts) {
            var nextSpan = addQualifyingParts.nextElementSibling;
            if (nextSpan && nextSpan.tagName === 'SPAN') {
                nextSpan.remove();
            }
            addQualifyingParts.insertAdjacentHTML('afterend', '<span>Please supply at least 1 quantity.</span>');
        }
        return false;
    }

    /**
     * Block UI to show add to cart
     */
    if (window.jQuery && window.jQuery.colorbox) {
        jQuery.colorbox({
            html: "<div class='modal common_modal login'>Please wait ... Adding free product...</div>"
        });
    }

    var qualifyingParts = $$$('#qualifyingParts');
    makeRequest("addQualifyingProduct.php", {
        data: qualifyingParts ? serializeForm(qualifyingParts) : ''
    }, function(msg) {
        var tableRow = '';

        //Clear the free table
        if (freeTable) {
            var tbody = freeTable.querySelector('tbody');
            if (tbody) tbody.innerHTML = '';
        }

        if (msg == '0') {
            if (window.jQuery && window.jQuery.colorbox) {
                jQuery.colorbox({
                    html: "<div class='modal common_modal login'>There was an issue making your request - please try again.</div>"
                });
            }
        } else {
            if (window.jQuery && window.jQuery.colorbox) {
                jQuery.colorbox({
                    html: "<div class='modal common_modal login'>Product added successfully.</div>",
                    onCleanup: function() {
                        var qualifyingPartContainer = $$$('#qualifyingPartContainer');
                        if (qualifyingPartContainer) addClass(qualifyingPartContainer, 'hide');
                    }
                });
            }

            /* Update product count */
            freeProductCount++;

            /* Show the table if freeProductCount > 0 */
            if (freeProductCount > 0 && freeTable) {
                removeClass(freeTable, 'hide');
            }

            //Add the product info to the table
            each(msg['catalogNumber'], function(key, val) {
                tableRow += '' +
                    '<tr>' +
                    '<td>' + val + '</td>' +
                    '<td>' +
                    '<a href="#" data-product-id="' + msg['insertID'][key] + '">remove</a>' +
                    '</td>' +
                    '</tr>';
            });
            if (freeTable) {
                freeTable.insertAdjacentHTML('beforeend', tableRow);
            }
        }
    });
}

function updateId() {
    //timestamp
    var ts = Math.round((new Date()).getTime() / 1000);

    //set hidden vars
    var sessionIDForMain = $$$('#sessionIDForMain');
    var sessionID = $$$('#sessionID');

    if (sessionIDForMain) sessionIDForMain.value = ts;
    if (sessionID) sessionID.value = ts;
}

function getManufacturerDropDown() {
    /**
     * Get all manufacturer data
     */
    makeRequest('/marketing-api/nlsu/manufacturersforoffers', {
        dataType: 'm',
        country: "US"
    }, function(msg) {
        if (msg === null) {
            if (window.jQuery && window.jQuery.colorbox) {
                jQuery.colorbox({
                    html: "<div class='modal common_modal login'>There was an issue getting Manufacturer Data - please refresh the page and try again</div>"
                });
            }
        } else {
            //Clear existing options
            var manufacturerID = $$$('#manufacturerID');
            if (manufacturerID) {
                $$('option', manufacturerID).forEach(function(option) {
                    if (option.value !== "0") {
                        option.remove();
                    }
                });
                if(msg['manufacturers']){
                    each(msg['manufacturers'], function(key, val) {
                        var option = document.createElement('option');
                        option.value = key.ManufacturerId;
                        option.textContent = key.manufacturerDesc;
                        manufacturerID.appendChild(option);
                    });
                }
            }
        }
    });
}